// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".StarsLink__stars___oxgu7{line-height:0;display:flex;justify-content:flex-start}.StarsLink__stars___oxgu7:focus{outline:0}", "",{"version":3,"sources":["webpack://./src/components/StarsLink/StarsLink.scss"],"names":[],"mappings":"AAAA,0BACE,aAAA,CACA,YAAA,CACA,0BAAA,CAEA,gCACE,SAAA","sourcesContent":[".stars {\n  line-height: 0;\n  display: flex;\n  justify-content: flex-start;\n\n  &:focus {\n    outline: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"stars": "StarsLink__stars___oxgu7"
};
export default ___CSS_LOADER_EXPORT___;
